import { render } from "./GetVerifiedComponent.vue?vue&type=template&id=5e8e7b2f"
import script from "./GetVerifiedComponent.vue?vue&type=script&lang=js"
export * from "./GetVerifiedComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__